import React, { useState, useEffect, MouseEvent, useRef } from 'react';
import './product.scss';
import Header from '../components/headerBar';
import Footer from '../components/footer';
import { Pagination, Tooltip, message } from 'antd';
import { listCatalogs, listProducts, ICatalogProps, IProductProps } from '../api/product';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import EXPAND_ARROW from '../assets/product/expand_arrow.png';
import PRODUCT_DESC_IMG from '../assets/default.png';
import QQ_IMG from '../assets/contact/qq.png';

interface ICatalog {
  catalogDes: string;
  catalogName: string;
  catalogNameEn: string;
  level: number;
  picUrl: string;
  id: number;
}

interface IProduct {
  boilingPoint: string;
  casNo: string;
  density: string;
  einecsNo: string;
  id: number;
  mdlNo: string;
  meltingPoint: string;
  molecularFormula: string;
  molecularWeight: string;
  nameCn: string;
  nameEn: string;
  picUrl: string;
  picDetailUrl: string;
  picRelaUrl: string;
  productNo: string;
  properties: string;
  purity: string;
  storageConditions: string;
}

interface IQueryProps {
  catalogId?: number | null;
  limit: number;
  page: number;
  queryKey?: string | null;
}

const map = Object.freeze({
  a: {
    en: 'Category_I',
    'zh-cn': '产品大类',
  },
  b: {
    en: 'Category_II',
    'zh-cn': '产品细类',
  },
  c: {
    en: 'Category_II',
    'zh-cn': '产品细类',
  },
  d: {
    en: 'pack up',
    'zh-cn': '收起',
  },
  e: {
    en: 'open',
    'zh-cn': '展开',
  },
  h: {
    en: 'Introduction',
    'zh-cn': '产品信息',
  },
  i: {
    en: 'code',
    'zh-cn': '产品编号',
  },
  j: {
    en: 'cas',
    'zh-cn': 'CAS号',
  },
  k: {
    en: 'alias',
    'zh-cn': '产品别名',
  },
  l: {
    en: 'formula',
    'zh-cn': '分子式',
  },
  m: {
    en: 'weight',
    'zh-cn': '分子量',
  },
  n: {
    en: 'all',
    'zh-cn': '全部',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Product = () => {
  const history = useHistory();

  const [firstCatalogList, setFirstCatalogList] = useState([]);
  const [secondCatalogList, setSecondCatalogList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [total, setTotal] = useState(0);
  const [firstExpand, setFirstExpand] = useState(true);
  const [secondExpand, setSecondExpand] = useState(true);
  const [firstCatalog, setFirstCatalog] = useState<number | null>(0);
  const [queryParams, setQueryParams] = useState<IQueryProps>({
    catalogId: null,
    limit: 12,
    page: 1,
    queryKey: '',
  });

  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const nameRef = useRef<(HTMLDivElement | null)[]>([]);

  const query = useQuery();

  const location = useLocation();

  const querySecondCatalog = (parentId: number | null) => {
    listCatalogs({
      level: 2,
      parentId,
    }).then((res) => {
      setSecondCatalogList(res.data);
      let secondType = query.get('secondType');
      setQueryParams({
        ...queryParams,
        catalogId: secondType ? Number(secondType) : parentId,
      });
    });
  };

  const queryProductsList = () => {
    listProducts(queryParams)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          console.log(res.data);
          setProductsList(res.data);
          setTotal(res.total);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const expandFirst = () => {
    setFirstExpand(!firstExpand);
  };

  const expandSecond = () => {
    setSecondExpand(!secondExpand);
  };

  const handleFirstCatalogClick = (id: number | null) => setFirstCatalog(id);

  const handlesecondCatalogClick = (catalogId: number | null) =>
    setQueryParams({
      ...queryParams,
      catalogId,
    });

  const toProductDetail = (id: number, e: MouseEvent) => {
    // if(e.target) {
    history.push(`/${la}/product/${id}`);
    // }
  };

  const changePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page,
    });
  };

  const goQQ = (event: React.MouseEvent<HTMLImageElement, globalThis.MouseEvent>, name: string) => {
    event.stopPropagation();
    var oInput = document.createElement('input');
    oInput.value = name;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display = 'none';
    message.success('你要咨询的产品名称已复制到电脑剪贴板');
    window.open('tencent://message/?uin=3007939906&Site=Sambow&Menu=yes', '_blank');
  };

  useEffect(() => {
    const queryFirstCatalog = () => {
      listCatalogs({
        level: 1,
      }).then((res) => {
        const type = query.get('type');
        setFirstCatalogList(res.data || []);
        if (Array.isArray(res.data) && res.data.length > 0 && !type) {
          setFirstCatalog(null);
        }
      });
    };
    queryFirstCatalog();
  }, []);

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  useEffect(() => {
    const search = query.get('search');
    const type = query.get('type');
    setQueryParams({
      ...queryParams,
      queryKey: search,
    });
    if (type) setFirstCatalog(+type);
  }, [location.search]);

  useEffect(() => {
    if (firstCatalog !== 0) {
      querySecondCatalog(firstCatalog);
    }
  }, [firstCatalog]);

  useEffect(() => {
    queryProductsList();
  }, [queryParams]);

  return (
    <div className='product'>
      <Header />
      <div className='product-container'>
        <div className='product-type-selector-container'>
          <div className='first-type type-container'>
            <div className='typename'>{map.a[la]}:</div>
            <div className={`type-content ${firstExpand ? '' : 'expand-close'}`}>
              <div
                className={`type-name ${firstCatalog === null ? 'active' : ''}`}
                onClick={() => handleFirstCatalogClick(null)}
              >
                {map.n[la]}
              </div>
              {firstCatalogList.map((catalog: ICatalog) => (
                <div
                  className={`type-name ${firstCatalog === catalog.id ? 'active' : ''}`}
                  key={catalog.id}
                  onClick={() => handleFirstCatalogClick(catalog.id)}
                >
                  {catalog.catalogName}
                </div>
              ))}
            </div>
            <div className={`expand ${firstExpand ? '' : 'expand-close'}`} onClick={expandFirst}>
              {firstExpand ? map.d[la] : map.e[la]}
              <img src={EXPAND_ARROW} alt='' />
            </div>
          </div>
          <div className='second-type type-container'>
            <div className='typename'>{map.b[la]}:</div>
            <div className={`type-content ${secondExpand ? '' : 'expand-close'}`}>
              <div
                className={`type-name ${queryParams.catalogId === firstCatalog ? 'active' : ''}`}
                onClick={() => handlesecondCatalogClick(firstCatalog)}
              >
                {map.n[la]}
              </div>
              {secondCatalogList.map((catalog: ICatalog) => (
                <div
                  className={`type-name ${queryParams.catalogId === catalog.id ? 'active' : ''}`}
                  key={catalog.id}
                  onClick={() => handlesecondCatalogClick(catalog.id)}
                >
                  {catalog.catalogName}
                </div>
              ))}
            </div>
            <div className={`expand ${secondExpand ? '' : 'expand-close'}`} onClick={expandSecond}>
              {secondExpand ? map.d[la] : map.e[la]}
              <img src={EXPAND_ARROW} alt='' />
            </div>
          </div>
        </div>
        <div className='product-list-container'>
          {productsList.map((product: IProduct, index: number) => {
            return (
              <div className='product-box' key={product.id} onClick={(e) => toProductDetail(product.id, e)}>
                <div className='first'>
                  <div className='img-container'>
                    <img src={product.picUrl || PRODUCT_DESC_IMG} alt='' />
                  </div>
                  <div className='title-content'>
                    <Tooltip title={product.nameEn}>
                      <div className='title'>{product.nameEn}</div>
                    </Tooltip>
                    <Tooltip placement='topLeft' title={product.nameCn}>
                      <div ref={(el) => nameRef.current.push(el)} className='sub-title'>
                        {product.nameCn}
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div className='second'>
                  <div className='product-desc'>
                    <div className='desc'>
                      <div className='title'>{map.i[la]}：</div>
                      <Tooltip title={product.productNo}>
                        <div className='content'>{product.productNo}</div>
                      </Tooltip>
                    </div>
                    <div className='desc'>
                      <div className='title'>{map.l[la]}：</div>
                      <Tooltip title={product.molecularFormula}>
                        <div className='content'>{product.molecularFormula}</div>
                      </Tooltip>
                    </div>
                    <div className='desc'>
                      <div className='title'>{map.j[la]}：</div>
                      <Tooltip title={product.casNo}>
                        <div className='content'>{product.casNo}</div>
                      </Tooltip>
                    </div>
                    <div className='desc'>
                      <div className='title'>{map.m[la]}：</div>
                      <Tooltip title={product.molecularWeight}>
                        <div className='content'>{product.molecularWeight}</div>
                      </Tooltip>
                    </div>
                  </div>
                  <div
                    className='contact'
                    onClick={(event: React.MouseEvent<HTMLImageElement, globalThis.MouseEvent>) =>
                      goQQ(event, product.nameCn)
                    }
                  >
                    <div>
                      <img src={QQ_IMG} alt='' />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className='product-pagation-container'>
          <Pagination
            hideOnSinglePage
            size='small'
            pageSize={12}
            showSizeChanger={false}
            total={total}
            onChange={changePage}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Product;
